export enum EngineType {
  INTERNAL_COMBUSTION_ENGINE = 'INTERNAL_COMBUSTION_ENGINE',
  EXTERNALLY_CHARGEABLE_HYBRID_ELECTRIC_VEHICLE = 'EXTERNALLY_CHARGEABLE_HYBRID_ELECTRIC_VEHICLE',
  NOT_EXTERNALLY_CHARGEABLE_HYBRID_ELECTRIC_VEHICLE = 'NOT_EXTERNALLY_CHARGEABLE_HYBRID_ELECTRIC_VEHICLE',
  PURE_ELECTRIC_VEHICLE = 'PURE_ELECTRIC_VEHICLE'
}

export enum EnergyManagementType {
  UNESPECIFIED = 'UNESPECIFIED',
  PURE = 'PURE',
  SUSTAINING = 'SUSTAINING'
}

export enum MimeType {
  SVG = 'image/svg+xml',
  PDF = 'application/pdf',
}
